import { CreateSkillDevelopment } from './create-skill-development.component';

export default CreateSkillDevelopment;
